import { element } from "protractor";
import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
// import * as firebase from "firebase";

import { Observable, of, Subject, Subscription } from "rxjs";
import {
  debounceTime,
  map,
  startWith,
  switchMap,
  distinctUntilChanged,
} from "rxjs/operators";
import { DataService } from "src/app/Services/dataservice.service";
import { EventEmitterService } from "src/app/Services/event-emitter.service";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { UserserviceService } from "src/app/Services/userservice.service";
import { BundleService } from "src/app/Services/bundleservice.service";
import { TitleandmetaserviceService } from "src/app/Services/titleandmetaservice.service";
import { BundledialogComponent } from "../bundledialog/bundledialog.component";
import { EmbededComponent, ShareEmbedDialogData } from "../embeded/embeded.component";
import { EmbedforbundlesComponent } from "../embedforbundles/embedforbundles.component";
import { MatDialog } from "@angular/material/dialog";
import { Location } from "@angular/common";
import { FlowQueryModel } from "src/app/models/flowquerymodel";
import { getConsultationDashboardPath } from "src/app/utils/consultation-notification-nav.util";
import { shouldAvatarOpenProfile } from "src/app/utils/notification-avatar-nav.util";
import { OwlOptions } from "ngx-owl-carousel-o";
import { ToastrService } from "ngx-toastr";
import { AuthModalService } from "src/app/Services/auth-modal.service";
import { TranslationService } from "src/app/Services/translation.service";
import {
  getFeedPosterUrl,
  isVideoMediaUrl,
  trackFeedItem,
} from "src/app/utils/feed-thumbnail.util";
import {
  normalizeUserProfilePic,
  resolveProfilePicUrl,
} from "src/app/utils/profile-pic.util";
import { OrganizationService } from "src/app/Services/organization.service";
import { OrgContextService } from "src/app/Services/org-context.service";
import { OrgNotificationService } from "src/app/Services/org-notification.service";
@Component({
  selector: "app-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.scss"],
})
export class SearchComponent implements OnInit, OnDestroy {
  userDisplayName: any;
  userData: any;
  currentImage: any;
  previousIndex: any;
  showImg = false;
  arrow = false;
  itemCount = 0;
  scrHeight: any;
  scrWidth: any;
  carouselOptions: any;
  profilePicture: string;
  name: string;
  email: string;
  website: string;
  phone: string;
  info: string;
  uname: string;
  flowData: any;
  categories: any[] = [];
  showDefaultImage: boolean;
  isMobileView: boolean;
  showNotificationCount: boolean;
  notificationCount: number;
  notificationtitle: any;
  notificationbody: any;
  notificationsarray: any[] = [];
  notificationscount: number;
  ProfilePic: any;
  input: string = "";
  orgLibraryItems: any[] = [];
  orgLibraryTitle: string | null = null;
  orgModeOnly = false;
  isLoadingOrgLibrary = false;
  private loginEventSub: Subscription | null = null;
  private accountTypeSub: Subscription | null = null;
  /** Org-mode category: Guides, Guide Packs, or Users (scoped members). */
  orgSelectedCategory: "Guides" | "GuidePacks" | "Users" = "Guides";
  /** Stable placeholder ids for skeleton *ngFor (avoid new arrays each CD cycle). */
  readonly skeletonCards: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  readonly skeletonCardsMore: number[] = [1, 2, 3, 4, 5, 6];
  otherUserEmail: string = "";
  noResultReturned: boolean;
  noAllResultReturned: boolean;
  itemsRequired: boolean;
  isSearchByFlows: boolean;
  isSearchByUsers: boolean;
  isSearchByBundle: boolean;

  automobilesbgColor: any;
  automobilesColor: any;

  adventuresbgColor: any;
  adventuresColor: any;
  artandCraftbgColor: any;
  artandCraftColor: any;

  beautyColor: any;
  beautybgColor: any;

  entertainmentColor: any;
  entertainmentbgColor: any;

  fashionbgColor: any;
  fashionColor: any;

  fitnessbgColor: any;
  fitnessColor: any;

  gamesbgColor: any;
  gamesColor: any;
  homeandbgGardenColor: any;
  homeandGardenColor: any;

  metalbgworksColor: any;
  metalworksColor: any;

  photographybgColor: any;
  photographyColor: any;

  recipebgColor: any;
  recipeColor: any;

  technologybgColor: any;
  technologyColor: any;

  woodworksbgColor: any;
  woodworksColor: any;

  userColor: any;
  userbgColor: any;

  userDisplayEmail: any;
  allFlowsbgColor: any;
  allFlowsColor: any;

  itemsRequiredbgColor: any;
  itemsRequiredColor: any;
  selectedcategory: any;

  myControl = new UntypedFormControl();
  options: string[] = [];
  flows: any[] = [];
  tempFlows: any[] = [];
  allUsers: any;
  tempUsers: any;

  private scrollSubject = new Subject<MouseEvent>();

  temporaryFlows: any = [];
  infiniteScrollCount: number;
  getNotificationUrl: string;
  filteredOptions: Observable<string[]>;
  bundlesbgColor: string;
  bundlesColor: string;

  private searchBundleTerms = new Subject<string>();
  private searchItemsRequiredTerms = new Subject<string>();
  private searchTerms = new Subject<string>();
  private searchTermsUsers = new Subject<string>();
  account_circle: string;
  add_circle_outlinebgColor: string;
  add_circle_outlineColor: string;
  add_circle_outlineSize: string;
  isthereanyNotifications: boolean;
  today: Date = new Date();
  yesterday: Date = new Date();
  thisWeekStart: Date = new Date();
  notificationsToday: any[] = [];
  notificationsYesterday: any[] = [];
  notificationsThisWeek: any[] = [];
  notificationsOlder: any[] = [];

  // Sidebar/search UI state
  sidebarCollapsed: boolean = false;
  isUserLoggedIn: boolean = false;
  isLoadingFlows: boolean = false;
  isLoadingMore: boolean = false;
  lastFlowsPageSize: number = 0; // track last page size for flows
  // Mobile header search state (search page specific)
  isMobileHeaderSearchOpen: boolean = false;

  // Filter & sort state
  showFilters: boolean = false;
  minPrice: number | null = null;
  maxPrice: number | null = null;
  sortBy: string = 'newest'; // 'newest' | 'price_asc' | 'price_desc' | 'free'

  get normalizedSearchTerm(): string {
    return (this.input || "").trim();
  }

  get shouldShowNoResultsMessage(): boolean {
    const term = this.normalizedSearchTerm;
    if (!term) {
      return false;
    }

    const viewingFlows =
      this.isSearchByFlows || this.isSearchByBundle || this.itemsRequired;
    const noFlowsAvailable =
      viewingFlows && (!this.tempFlows || this.tempFlows.length === 0);
    const noUsersAvailable =
      this.isSearchByUsers && (!this.tempUsers || this.tempUsers.length === 0);
    const notLoading = !this.isLoadingFlows && !this.isLoadingMore;

    return notLoading && (noFlowsAvailable || noUsersAvailable);
  }

  /** Comma-separated item names from the current `q` param (Items search). */
  get itemQueryTerms(): string[] {
    if (!this.itemsRequired) {
      return [];
    }
    return (this.input || "")
      .split(",")
      .map((s) => s.trim())
      .filter((s) => s.length > 0);
  }

  /** Items terms: show pills above the category bar (not in the header). */
  get showItemQueryTermsRow(): boolean {
    return this.itemsRequired && this.itemQueryTerms.length > 0;
  }

  removeItemQueryTerm(index: number): void {
    const terms = [...this.itemQueryTerms];
    if (index < 0 || index >= terms.length) {
      return;
    }
    terms.splice(index, 1);
    const q = terms.join(", ").trim();
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { q: q || null },
      queryParamsHandling: "merge",
      replaceUrl: true,
    });
  }

  /** Keep header search bar in sync when switching Flows / Users / Bundles / Items tabs. */
  private syncCategoryQueryParam(category: string): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { category },
      queryParamsHandling: "merge",
      replaceUrl: true,
    });
  }

  /** Show price/sort filters only for flow and bundle categories. */
  get showPriceFilter(): boolean {
    return this.selectedcategory === 'All' || this.selectedcategory === 'Bundles';
  }

  get activeFilterCount(): number {
    let count = 0;
    if (this.minPrice !== null && this.minPrice !== undefined && this.minPrice !== ('' as any) && !isNaN(+this.minPrice)) count++;
    if (this.maxPrice !== null && this.maxPrice !== undefined && this.maxPrice !== ('' as any) && !isNaN(+this.maxPrice)) count++;
    if (this.sortBy !== 'newest') count++;
    return count;
  }

  /**
   * A flow is free when isPaid is false AND price is null/empty/0.
   * A flow is paid when isPaid is true AND price > 0.
   */
  private isFlowFree(item: any): boolean {
    const isPaid = item?.isPaid === true || item?.IsPaid === true;
    if (isPaid) return false;
    const p = parseFloat(item?.price);
    return isNaN(p) || p <= 0;
  }

  private isFlowPaid(item: any): boolean {
    const isPaid = item?.isPaid === true || item?.IsPaid === true;
    const p = parseFloat(item?.price);
    return isPaid && !isNaN(p) && p > 0;
  }

  /** Returns the numeric price for a paid flow, or null if not a paid flow. */
  private getItemPrice(item: any): number | null {
    if (!this.isFlowPaid(item)) return null;
    const p = parseFloat(item?.price);
    return isNaN(p) ? null : p;
  }

  /** Client-side filtered and sorted view of tempFlows. */
  get filteredFlows(): any[] {
    if (!this.showPriceFilter || this.activeFilterCount === 0) {
      return this.tempFlows || [];
    }
    let result = [...(this.tempFlows || [])];

    if (this.sortBy === 'free') {
      // Free: isPaid === false AND price is null/empty/0
      result = result.filter(f => this.isFlowFree(f));
    } else {
      const minVal = (this.minPrice !== null && this.minPrice !== undefined && this.minPrice !== ('' as any) && !isNaN(+this.minPrice))
        ? +this.minPrice : null;
      const maxVal = (this.maxPrice !== null && this.maxPrice !== undefined && this.maxPrice !== ('' as any) && !isNaN(+this.maxPrice))
        ? +this.maxPrice : null;

      if (minVal !== null) {
        result = result.filter(f => {
          const p = this.getItemPrice(f);
          return p !== null && p >= minVal!;
        });
      }
      if (maxVal !== null) {
        result = result.filter(f => {
          const p = this.getItemPrice(f);
          return p !== null && p <= maxVal!;
        });
      }
    }

    if (this.sortBy === 'price_asc') {
      // Only paid flows (isPaid true, price > 0); exclude free/unpaid entirely
      result = result.filter(f => this.isFlowPaid(f));
      result.sort((a, b) => (this.getItemPrice(a) as number) - (this.getItemPrice(b) as number));
    } else if (this.sortBy === 'price_desc') {
      // Only paid flows (isPaid true, price > 0); exclude free/unpaid entirely
      result = result.filter(f => this.isFlowPaid(f));
      result.sort((a, b) => (this.getItemPrice(b) as number) - (this.getItemPrice(a) as number));
    }
    return result;
  }

  getFeedPosterUrl = getFeedPosterUrl;
  trackFlowCard = trackFeedItem;

  /** Cover for org-library cards (API CoverUrl, Url image, or video poster). */
  orgLibraryCoverUrl(item: any): string | null {
    if (!item) return null;
    const cover =
      item.coverUrl ||
      item.CoverUrl ||
      "";
    const media = item.url || item.Url || "";
    const poster =
      item.videoThumbNailUrl ||
      item.VideoThumbNailUrl ||
      "";
    const trimmedCover = String(cover).trim();
    if (trimmedCover) return trimmedCover;
    const mediaTrim = String(media).trim();
    if (mediaTrim && !isVideoMediaUrl(mediaTrim)) return mediaTrim;
    const posterTrim = String(poster).trim();
    return posterTrim || null;
  }

  /** Public unique id for org-library cards. */
  orgLibraryUniqueId(item: any): string {
    if (!item) return "N/A";
    const id = item.uniqueId || item.UniqueId || "";
    return String(id).trim() || "N/A";
  }

  /** Creator full name for org-library cards. */
  orgLibraryCreatorName(item: any): string {
    if (!item) return "Unknown";
    const name =
      item.ownerDisplayName ||
      item.OwnerDisplayName ||
      item.firstName ||
      item.FirstName ||
      "";
    const handle = item.ownerUserName || item.OwnerUserName || item.userName || "";
    if (String(name).trim()) return String(name).trim();
    if (String(handle).trim()) return String(handle).trim().replace(/^@/, "");
    const email = item.ownerEmail || item.OwnerEmail || "";
    return email ? String(email).split("@")[0] : "Unknown";
  }

  /** Creator full name on public feed cards (prefer FirstName over @handle). */
  creatorDisplayName(item: any): string {
    if (!item) return "";
    const full =
      item.firstName ||
      item.FirstName ||
      item.ownerDisplayName ||
      item.OwnerDisplayName ||
      "";
    if (String(full).trim()) return String(full).trim();
    const handle = item.userName || item.UserName || "";
    return String(handle).trim();
  }

  toggleFilters(): void {
    this.showFilters = !this.showFilters;
  }

  clearFilters(): void {
    this.minPrice = null;
    this.maxPrice = null;
    this.sortBy = 'newest';
  }

  onFilterChange(): void {
    this.changeDetectorRef.detectChanges();
  }

  constructor(
    public dialog: MatDialog,
    private location: Location,
    private flowServiceService: FlowServiceService,
    private router: Router,
    private route: ActivatedRoute,
    private dataService: DataService,

    private userserviceService: UserserviceService,
    private eventEmitterService: EventEmitterService,
    private changeDetectorRef: ChangeDetectorRef,
    private ref: ChangeDetectorRef,
    private bundleService: BundleService,
    private titleandmetaserviceService: TitleandmetaserviceService,
    private eventService: EventEmitterService,
    private toastr: ToastrService,
    public authModalService: AuthModalService,
    private translationService: TranslationService,
    private organizationService: OrganizationService,
    private orgContextService: OrgContextService,
    private orgNotificationService: OrgNotificationService
  ) {
    this.titleandmetaserviceService.setTitle("Home Page");
    this.getNotificationUrl = "v1/Notification/GetUserNotifications";
    this.categories = [];
    this.getScreenSize();
    this.eventEmitterService.callEvent();
    this.eventEmitterService.setHomePageIconColorEvent("search");
    this.itemsRequired = false;
    this.isSearchByFlows = true;
    this.isSearchByUsers = false;
    this.isSearchByBundle = false;
    this.selectedcategory = "All";
    this.userDisplayEmail = "";
    this.infiniteScrollCount = 4;
    this.account_circle = "account_circle";
    if (this.eventEmitterService.setProfilePictureCompleted === undefined) {
      this.eventEmitterService.setProfilePictureCompleted =
        this.eventEmitterService.setProfilePictureFunction.subscribe(
          (profilePicture: string) => {
            this.showDefaultImage = false;
            this.profilePicture = profilePicture;
          }
        );
    }

    this.searchTerms
      .pipe(
        debounceTime(400), // short debounce so new request cancels previous quickly
        distinctUntilChanged(),
        switchMap((term: string) => {
          const trimmed = (term || "").trim();

          // Empty term: emit empty result so UI clears; no API call
          if (trimmed.length === 0) {
            return of({ term: "", data: { flows: [] } });
          }

          // reset paging for new term
          localStorage.removeItem("pageIndex");
          localStorage.setItem("pageIndex", "0");

          // set loading flags (equivalent to performSearch(0))
          this.noResultReturned = true;
          this.noAllResultReturned = true;
          this.email = "";

          if (this.userData != null) {
            this.email = this.userData.emailAddress;
          }

          this.isLoadingFlows = true;

          const flowQueryModel = new FlowQueryModel({
            category: this.selectedcategory,
            searchString: trimmed,
            userEmail: this.email,
            pageIndex: 0,
          });

          // switchMap unsubscribes from this when a new term arrives → cancels previous request
          return this.flowServiceService
            .searchInFlows(flowQueryModel)
            .pipe(map((data) => ({ term: trimmed, data })));
        })
      )
      .subscribe(({ term, data }) => {
        // If input has changed since this request was sent, ignore this response
        if ((this.input || "").trim() !== (term || "").trim()) {
          return;
        }

        // handle results (equivalent to performSearch body for pageIndex === 0)
        this.tempFlows = [];
        this.noResultReturned = false;
        this.noAllResultReturned = false;
        this.isLoadingFlows = false;
        this.isLoadingMore = false;

        const flows = data?.flows || [];
        this.lastFlowsPageSize = flows.length;

        if (flows.length > 0) {
          // For typed search we replace the list with exactly what API returns
          this.tempFlows = flows;
          // Allow further scroll only when we got a full page
          this.allFlowsLoaded = this.lastFlowsPageSize < this.pageSize;
        } else {
          this.allFlowsLoaded = true;
        }

        this.scheduleRetranslate();
      });

    // Keep users search behaviour as before (no custom switchMap logic here),
    // just debounce and call existing performUsersSearch.
    this.searchTermsUsers
      .pipe(debounceTime(2000))
      .subscribe(() => {
        this.performUsersSearch(0);
      });

    this.searchBundleTerms
      .pipe(
        debounceTime(2000),
        distinctUntilChanged(),
        switchMap((term: string) => {
          localStorage.removeItem("pageIndex");
          localStorage.setItem("pageIndex", "0");

          this.noResultReturned = true;
          this.noAllResultReturned = true;
          this.email = "";

          if (this.userData != null) {
            this.email = this.userData.emailAddress;
          }

          this.isLoadingFlows = true;

          const flowQueryModel = new FlowQueryModel({
            category: this.selectedcategory,
            searchString: term,
            userEmail: this.email,
            pageIndex: 0,
          });

          return this.flowServiceService
            .searchInBundles(flowQueryModel)
            .pipe(map((data) => ({ term, data })));
        })
      )
      .subscribe(({ term, data }) => {
        if ((this.input || "").trim() !== (term || "").trim()) {
          return;
        }

        if (this.userData != null) {
          this.email = this.userData.emailAddress;
        }

        this.tempFlows = [];
        this.noResultReturned = false;
        this.noAllResultReturned = false;
        this.isLoadingFlows = false;
        this.isLoadingMore = false;

        if (data?.flows != null && data.flows.length > 0) {
          data.flows.forEach((element) => {
            this.tempFlows.push(element);
          });
          this.allFlowsLoaded = false;
        } else {
          this.allFlowsLoaded = true;
        }

        this.scheduleRetranslate();
      });

    this.searchItemsRequiredTerms
      .pipe(
        debounceTime(2000),
        distinctUntilChanged(),
        switchMap((term: string) => {
          this.noResultReturned = true;
          this.noAllResultReturned = true;
          this.email = "";

          if (this.userData != null) {
            this.email = this.userData.emailAddress;
          }

          const flowQueryModel = new FlowQueryModel({
            category: this.selectedcategory,
            searchString: term,
            userEmail: this.email,
            otherUserEmail: this.otherUserEmail,
            pageIndex: 0,
          });

          return this.flowServiceService
            .searchInItemsRequired(flowQueryModel)
            .pipe(map((data) => ({ term, data })));
        })
      )
      .subscribe(({ term, data }) => {
        if ((this.input || "").trim() !== (term || "").trim()) {
          return;
        }

        this.tempFlows = [];
        this.noResultReturned = false;
        this.noAllResultReturned = false;
        this.isLoadingFlows = false;
        this.isLoadingMore = false;

        if (data?.flows != null && data.flows.length > 0) {
          data.flows.forEach((element) => {
            this.tempFlows.push(element);
          });
          this.allFlowsLoaded = false;
        } else {
          this.allFlowsLoaded = true;
        }

        this.scheduleRetranslate();
      });
  }

  performItemsRequiredSearch(pageIndex) {
    this.noResultReturned = true;
    this.noAllResultReturned = true;
    this.email = "";

    if (this.userData != null) {
      this.email = this.userData.emailAddress;
    }

    var flowQueryModel = new FlowQueryModel({
      category: this.selectedcategory,
      searchString: this.input,
      userEmail: this.email,
      otherUserEmail: this.otherUserEmail,
      pageIndex: pageIndex,
    });

    this.flowServiceService
      .searchInItemsRequired(flowQueryModel)
      .subscribe((data) => {
        if (pageIndex === 0) {
          this.tempFlows = [];
        }
        this.noResultReturned = false;
        this.noAllResultReturned = false;
        this.isLoadingFlows = false;
        this.isLoadingMore = false;
        if (
          data.flows != null &&
          data.flows != undefined &&
          data.flows.length > 0
        ) {
          data.flows.forEach((element) => {
            this.tempFlows.push(element);
          });
          this.allFlowsLoaded = false;
        } else {
          this.allFlowsLoaded = true;
        }
        this.scheduleRetranslate();
      });
  }

  private scheduleRetranslate(): void {
    if (this.translationService.getCurrentTranslationLanguage()) {
      setTimeout(() => this.translationService.retranslateForNewContent(), 200);
    }
  }

  performUsersSearch(pageIndex) {
    if (this.orgModeOnly && this.orgContextService.canViewUsersTab()) {
      this.loadOrgMembers(pageIndex);
      return;
    }

    // Public account: platform-wide user discovery.
    this.noResultReturned = true;
    this.noAllResultReturned = true;
    this.allUsers = [];
    this.tempUsers = [];

    var flowQueryModel = new FlowQueryModel({
      category: this.selectedcategory,
      searchString: this.input,
      userEmail: this.email,
      otherUserEmail: this.otherUserEmail,
      pageIndex: pageIndex,
    });

    this.userserviceService.searchInUsers(flowQueryModel).subscribe((data) => {
      this.noResultReturned = false;
      this.noAllResultReturned = false;
      this.isLoadingFlows = false;
      this.isLoadingMore = false;
      if (data?.allUsers?.length > 0) {
        this.tempUsers = [];
        this.allUsers = [];
        data.allUsers.forEach((element) => {
          normalizeUserProfilePic(element);
          const user = {
            user: element,
            showFollow: false,
            followButtonText: element.followingText,
          };
          this.allUsers.push(user);
        });

        this.tempUsers = this.allUsers;
        this.tempUsers.forEach((element) => {
          if (element.followButtonText === "Following") {
            element.followButtonText = "Following";
            element.followingcolor = "black";
            element.followingbgcolor = "white";
          } else {
            element.followButtonText = "Follow";
            element.followingcolor = "white";
            element.followingbgcolor = "#5ea1d8";
          }
        });
        this.allFlowsLoaded = false;
      } else {
        this.allFlowsLoaded = true;
      }
      this.changeDetectorRef.detectChanges();
    });
  }

  private loadOrgMembers(pageIndex: number | string): void {
    const orgId =
      this.orgContextService.snapshot.activeOrganization?.organizationId ||
      localStorage.getItem("activeOrganizationId");
    if (!orgId || !this.orgContextService.canViewUsersTab()) {
      this.allUsers = [];
      this.tempUsers = [];
      this.isLoadingFlows = false;
      this.isLoadingMore = false;
      this.allFlowsLoaded = true;
      this.changeDetectorRef.detectChanges();
      return;
    }

    const idx =
      typeof pageIndex === "string" ? parseInt(pageIndex, 10) || 0 : pageIndex || 0;
    const appId =
      this.orgContextService.snapshot.activeApplicationId || undefined;
    const teamId = this.orgContextService.snapshot.activeTeamId || undefined;

    this.noResultReturned = true;
    this.isLoadingFlows = true;
    if (idx === 0) {
      this.allUsers = [];
      this.tempUsers = [];
    }

    this.organizationService
      .listMembers(orgId, {
        applicationId: appId,
        teamId: teamId,
        q: (this.input || "").trim() || undefined,
        pageIndex: idx,
        pageSize: 20,
      })
      .subscribe({
        next: (data) => {
          this.noResultReturned = false;
          this.noAllResultReturned = false;
          this.isLoadingFlows = false;
          this.isLoadingMore = false;
          const members = data?.members || [];
          if (idx === 0) {
            this.allUsers = [];
            this.tempUsers = [];
          }
          members.forEach((element: any) => {
            const mapped = {
              emailAddress: element.email || element.Email,
              firstName:
                (element.displayName || element.DisplayName || "").split(
                  " "
                )[0] || "",
              lastName: (element.displayName || element.DisplayName || "")
                .split(" ")
                .slice(1)
                .join(" "),
              userName: element.userName || element.UserName,
              profilePicUrl: element.profilePicUrl || element.ProfilePicUrl,
              followingText: "Follow",
              role: element.role || element.Role,
              roleLabel: this.orgContextService.roleDisplayName(
                element.role || element.Role
              ),
            };
            normalizeUserProfilePic(mapped);
            this.allUsers.push({
              user: mapped,
              showFollow: false,
              followButtonText: "Follow",
              followingcolor: "white",
              followingbgcolor: "#5ea1d8",
            });
          });
          this.tempUsers = this.allUsers;
          const total = data?.totalCount ?? members.length;
          this.allFlowsLoaded = this.allUsers.length >= total;
          this.changeDetectorRef.detectChanges();
        },
        error: () => {
          this.noResultReturned = false;
          this.isLoadingFlows = false;
          this.isLoadingMore = false;
          this.allFlowsLoaded = true;
          this.changeDetectorRef.detectChanges();
        },
      });
  }

  /** Whether the Org/App/Team admin Users tab is available. */
  get canViewUsersTab(): boolean {
    return this.orgModeOnly && this.orgContextService.canViewUsersTab();
  }

  /** Org library items for the active Guides / Guide Packs chip. */
  get filteredOrgLibraryItems(): any[] {
    const items = this.orgLibraryItems || [];
    if (this.orgSelectedCategory === "GuidePacks") {
      return items.filter(
        (i) => (i.contentType || i.ContentType) === "GuidePack"
      );
    }
    return items.filter(
      (i) => (i.contentType || i.ContentType) !== "GuidePack"
    );
  }

  selectOrgCategory(category: "Guides" | "GuidePacks" | "Users"): void {
    this.orgSelectedCategory = category;
    if (category === "Users") {
      if (!this.canViewUsersTab) {
        this.orgSelectedCategory = "Guides";
        return;
      }
      this.selectedcategory = "Users";
      this.isSearchByUsers = true;
      this.isSearchByFlows = false;
      this.isSearchByBundle = false;
      this.isLoadingFlows = true;
      this.allUsers = [];
      this.tempUsers = [];
      this.changeDetectorRef.detectChanges();
      this.getAllUsers("Users");
      return;
    }
    this.isSearchByUsers = false;
    this.isSearchByFlows = category === "Guides";
    this.isSearchByBundle = category === "GuidePacks";
    this.selectedcategory = category === "GuidePacks" ? "Bundles" : "All";
    this.syncCategoryQueryParam(
      category === "GuidePacks" ? "Bundles" : "All"
    );
    this.tempUsers = [];
    this.allUsers = [];
    if (!this.orgLibraryItems?.length && !this.isLoadingOrgLibrary) {
      this.loadOrgLibrary();
    }
  }

  /** True while the org Users tab should show skeleton placeholders. */
  get showOrgUsersSkeleton(): boolean {
    return (
      this.orgSelectedCategory === "Users" &&
      this.isSearchByUsers &&
      this.isLoadingFlows &&
      (!this.tempUsers || this.tempUsers.length === 0)
    );
  }

  performSearch(pageIndex) {
    this.noResultReturned = true;
    this.noAllResultReturned = true;
    this.email = "";

    if (pageIndex === 0) {
      this.isLoadingFlows = true;
    }

    if (this.userData != null) {
      this.email = this.userData.emailAddress;
    }

    var flowQueryModel = new FlowQueryModel({
      category: this.selectedcategory,
      searchString: this.input,
      userEmail: this.email,
      pageIndex: pageIndex,
    });

    this.flowServiceService.searchInFlows(flowQueryModel).subscribe((data) => {
      if (pageIndex === 0) {
        this.tempFlows = [];
      }
      this.noResultReturned = false;
      this.noAllResultReturned = false;
      this.isLoadingFlows = false;
      this.isLoadingMore = false;

      const flows = data?.flows || [];
      this.lastFlowsPageSize = flows.length;

      if (flows.length > 0) {
        // Append all flows from this page; UI shows full result set
        flows.forEach((element) => {
          this.tempFlows.push(element);
        });
        // Only allow further scroll if we got a full page (15 results)
        this.allFlowsLoaded = this.lastFlowsPageSize < this.pageSize;
      } else {
        this.allFlowsLoaded = true;
      }
      this.scheduleRetranslate();
    });
  }

  performBundleSearch(pageIndex) {
    console.log("performBundleSearch");
    this.noResultReturned = true;
    this.noAllResultReturned = true;
    this.email = "";

    if (pageIndex === 0) {
      this.isLoadingFlows = true;
    }

    if (this.userData != null) {
      this.email = this.userData.emailAddress;
    }

    var flowQueryModel = new FlowQueryModel({
      category: this.selectedcategory,
      searchString: this.input,
      userEmail: this.email,
      pageIndex: pageIndex,
    });

    this.flowServiceService
      .searchInBundles(flowQueryModel)
      .subscribe((data) => {
        if (pageIndex === 0) {
          this.tempFlows = [];
        }
        this.noResultReturned = false;
        this.noAllResultReturned = false;
        this.isLoadingFlows = false;
        this.isLoadingMore = false;
        if (
          data.flows != null &&
          data.flows != undefined &&
          data.flows.length > 0
        ) {
          data.flows.forEach((element) => {
            this.tempFlows.push(element);
          });
          this.allFlowsLoaded = false;
        } else {
          this.allFlowsLoaded = true;
        }
        this.scheduleRetranslate();
      });
  }

  searchBundles() {
    this.searchBundleTerms.next(this.input);
  }

  ngOnInit(): void {
    this.allFlowsLoaded = false;
    this.flowServiceService.setScrollTop();
    // Org library home only when account type is Organization.
    // Never force org UI when the user explicitly chose (or defaulted to) Public.
    const savedMode =
      typeof localStorage !== "undefined"
        ? localStorage.getItem("accountUsageMode")
        : null;
    const isPublicAccount =
      savedMode === "public" ||
      this.orgContextService.snapshot.accountUsageMode === "public";
    const hasActiveOrg =
      !!this.orgContextService.snapshot.activeOrganization?.organizationId ||
      !!localStorage.getItem("activeOrganizationId");
    const preferOrgHome =
      !isPublicAccount &&
      (this.orgContextService.isOrganizationMode() ||
        savedMode === "organization" ||
        (!savedMode && hasActiveOrg));
    if (preferOrgHome) {
      this.orgModeOnly = true;
      this.isLoadingOrgLibrary = true;
      this.tempFlows = [];
    } else {
      this.orgModeOnly = false;
    }
    this.loadOrgLibrary();

    // Public feed skeleton (skipped when org library is the home surface)
    if (!this.orgModeOnly) {
      this.isLoadingFlows = true;
      this.tempFlows = [];
    }

    // Default to "All" unless query params override it
    this.selectedcategory = "All";
    this.setallgray("All");

    // Handle query parameters from global search
    this.route.queryParams.subscribe((params) => {
      const queryParam = (params["q"] || "").trim();
      const hasQueryParam = queryParam.length > 0;

      if (hasQueryParam) {
        if (this.input !== queryParam) {
          this.input = queryParam;
        }
        this.isLoadingFlows = true;
        this.tempFlows = [];
        this.allFlowsLoaded = false;

        // When both `q` and `category` are present, apply category first (otherwise
        // first load stays on "All" and Items+multi-term search never runs).
        const catParam = (params["category"] || "").toString();
        if (catParam === "Items") {
          this.selectedcategory = "Items Required";
          this.setallgray("Items Required");
        } else if (catParam === "Users") {
          if (this.orgModeOnly && !this.orgContextService.canViewUsersTab()) {
            this.selectedcategory = "All";
            this.orgSelectedCategory = "Guides";
            this.setallgray("All");
          } else {
            this.selectedcategory = "Users";
            if (this.orgModeOnly) {
              this.orgSelectedCategory = "Users";
            }
            this.setallgray("Users");
          }
        } else if (catParam === "Bundles") {
          this.selectedcategory = "Bundles";
          this.setallgray("Bundles");
          if (this.orgModeOnly) {
            this.orgSelectedCategory = "GuidePacks";
            this.isSearchByBundle = true;
            this.isSearchByFlows = false;
            this.isSearchByUsers = false;
          }
        } else if (catParam === "All") {
          this.selectedcategory = "All";
          this.setallgray("All");
          if (this.orgModeOnly) {
            this.orgSelectedCategory = "Guides";
          }
        }

        // Run search based on the currently highlighted category
        const currentCategory = this.selectedcategory || "All";
        if (currentCategory === "Users") {
          if (this.orgModeOnly && !this.orgContextService.canViewUsersTab()) {
            this.isSearchByFlows = true;
            this.isSearchByUsers = false;
            this.isSearchByBundle = false;
            this.searchTerms.next(queryParam);
          } else {
            this.isSearchByFlows = false;
            this.isSearchByUsers = true;
            this.isSearchByBundle = false;
            if (this.orgModeOnly) {
              this.orgSelectedCategory = "Users";
            }
            this.performUsersSearch(0);
          }
        } else if (currentCategory === "Bundles") {
          this.isSearchByFlows = true; // bundles also shown in flows grid
          this.isSearchByUsers = false;
          this.isSearchByBundle = true;
          if (this.orgModeOnly) {
            this.orgSelectedCategory = "GuidePacks";
            // Org home filters library client-side; no public bundle search.
            this.isLoadingFlows = false;
          } else {
            this.performBundleSearch(0);
          }
        } else if (currentCategory === "Items Required") {
          this.isSearchByFlows = true; // items required uses flows grid
          this.isSearchByUsers = false;
          this.isSearchByBundle = false;
          this.performItemsRequiredSearch(0);
        } else {
          // Default to Flows: route through searchTerms so switchMap cancels previous request
          this.isSearchByFlows = true;
          this.isSearchByUsers = false;
          this.isSearchByBundle = false;
          this.searchTerms.next(queryParam);
        }
      } else {
        if (this.orgModeOnly) {
          // Organization home: do not load the public feed.
          // Keep isLoadingOrgLibrary true until listLibrary returns.
          this.isLoadingFlows = false;
          this.tempFlows = [];
          this.allFlowsLoaded = true;
          return;
        }
        if (this.input) {
          this.input = "";
        }
        if (params["category"]) {
          const category = params["category"];
          if (category === "All") {
            this.flowByCategory("All");
          } else if (category === "Users") {
            if (this.orgModeOnly && !this.orgContextService.canViewUsersTab()) {
              this.flowByCategory("All");
            } else {
              this.getAllUsers("Users");
            }
          } else if (category === "Bundles") {
            this.getAllBundles("Bundles");
          } else if (category === "Items") {
            this.flowByCategory("Items Required");
          }
        } else {
          // No query params, load default flows
          this.selectedcategory = "All";
          this.setallgray("All");
          this.getFlows();
        }
      }
    });

    // this.eventEmitterService.setNotificationCompleted =
    //   this.eventEmitterService.setNotificationFunction.subscribe(
    //     (notificationModelArray: any) => {
    //       this.notificationsarray = [];
    //       this.showNotificationCount = true;
    //       const notifications = JSON.parse(notificationModelArray);
    //       notifications.forEach((element) => {
    //         this.notificationsarray.push(element.notification);
    //       });
    //       this.notificationscount = this.notificationsarray.length;
    //       this.ref.detectChanges();
    //     }
    //   );
    //

    this.syncAuthFromStorage();

    if (this.userData != null) {
      this.eventEmitterService.setUserProfileCreateIconClickedEvent("search");
      // this.getnotification();
      this.getProfileUser();
    }

    this.loginEventSub = this.eventEmitterService.setLoggedInUserDataProperty.subscribe(
      (loggedIn: boolean) => {
        this.syncAuthFromStorage(loggedIn);
        if (loggedIn) {
          this.applyAccountTypeAfterLogin();
        }
      }
    );

    //this.getProfileUser();
    this.eventEmitterService.callEvent();

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value))
    );

    // if (this.eventEmitterService.setNotificationCompleted === undefined) {
    //   this.eventEmitterService.setNotificationCompleted =
    //     this.eventEmitterService.setNotificationFunction.subscribe(
    //       (notificationModelArray: any) => {
    //         this.showNotificationCount = true;
    //         this.notificationscount = notificationModelArray.length;
    //         this.notificationsarray = notificationModelArray;
    //       }
    //     );
    // }

    this.scrollSubject.pipe(debounceTime(1000)).subscribe({
      next: (event: MouseEvent) => {
        this.performScroll(event as MouseEvent);
      },
      error: (error) => {
        console.error("Error in scroll subscription:", error);
      },
    });

    // Initialize mobile view flag once on load
    const initialWidth = window.innerWidth || document.body.clientWidth;
    this.isMobileView = initialWidth <= 955;
  }


  performScroll(event: MouseEvent) {
    this.delayedServiceCall();
  }

  getProfileUser(): void {
    if (this.userData != null) {
      //
      this.showNotificationCount = true;
      this.userserviceService.getProfileUser().subscribe((data) => {
        if (
          data.userData.profilePicUrl === "" ||
          data.userData.profilePicUrl == null
        ) {
          this.showDefaultImage = true;
        } else {
          this.showDefaultImage = false;
          this.profilePicture = resolveProfilePicUrl(data.userData.profilePicUrl);
        }
        this.email = data.userData.emailAddress;
        this.phone = data.userData.phoneNumber;
        this.info = data.userData.info;
        this.website = data.userData.website;
        this.uname = data.userData.userName;
        this.name = data.userData.firstName;
        //
        this.getnotification();
      });
    }
  }
  allFlowsLoaded: boolean = false;
  page: number = 1; // Keep track of pages for pagination
  pageSize: number = 15; // Must match backend StorageHelper.PageSize

  // Legacy loadMoreFlows kept for reference but no longer used; scrolling is handled via delayedServiceCall.

  // avatarClicked(notification: any, source: any) {
  //   if (source == "flow clicked") {
  //     localStorage.setItem("notificationflowId", notification.rowKey);
  //     localStorage.setItem("flow", null);
  //     this.router.navigate(["/view/" + notification.rowKey]);
  //   } else if (source == "profile clicked") {
  //   }
  // }

  avatarProfileClicked(notification: any, source: any) {
    if (source === "flow clicked") {
      this.avatarClicked(notification, "flow clicked");
      return;
    }
    this.avatarClicked(notification, "profile clicked");
  }

  avatarClicked(notification: any, source: any) {
    console.log(notification);
    if (source === "profile clicked") {
      if (shouldAvatarOpenProfile(notification)) {
        if (this.userData.emailAddress == notification.NotifierUserEmail) {
          this.router.navigate(["/user-profile"]);
        } else if (notification.NotifierUserEmail) {
          this.dataService.flowByCategorieschangeMessage(notification);
          this.router.navigate(["/view-profile"]);
        }
        return;
      }
      return;
    }

    if (this.orgNotificationService.open(notification)) {
      return;
    }

    if (notification.ContentType == "Flow") {
      localStorage.setItem("notificationflowId", notification.ContentId);
      localStorage.setItem("flow", null);
      this.router.navigate([
        `/guide/${this.generateUrlSlug(notification.ContentTitle)}/${
          notification.ContentId
        }`,
      ]);
    } else if (notification.ContentType == "Bundle") {
      this.router.navigate(["/view-guide-pack/" + notification.NotifierCustomerId]);
    } else if (notification.ContentType == "User Following") {
      if (this.userData.emailAddress == notification.NotifierUserEmail) {
        //localStorage.setItem("LoggedInUser", notification.NotifierUserEmail);
        this.router.navigate(["/user-profile"]);
      } else {
        console.log(notification.NotifierUserEmail);
        this.dataService.flowByCategorieschangeMessage(notification);
        this.router.navigate(["/view-profile"]);
      }
    } else if (notification.ContentType == "Consult") {
      const path = getConsultationDashboardPath(
        notification,
        this.userData?.emailAddress
      );
      this.router.navigate([path]);
    } else if (notification.ContentType == "Collaboration") {
      this.router.navigate(["/collaboration-requests"]);
    }
  }

  checkLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    } else {
      this.eventEmitterService.setUserProfileCreateIconClickedEvent(
        "notifications"
      );
      this.router.navigate(["/create-guide"]);
    }
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    } else {
      this.getnotification();
    }
  }
  @HostListener("window:resize", ["$event"])
  getScreenSize(event?) {
    this.resize();
  }

  resize() {
    this.carouselOptions = {
      margin: 0,
      nav: true,
      dots: false,
      pagination: false,
      responsiveClass: true,
      responsive: {
        0: {
          items: 2,
          nav: true,
        },
        460: {
          items: 2,
          nav: true,
        },
        550: {
          items: 3,
          nav: true,
        },
        600: {
          items: 3,
          nav: true,
        },
        700: {
          items: 3,
          nav: true,
        },
        768: {
          items: 3,
          nav: true,
        },
        800: {
          items: 3,
          nav: true,
        },
        900: {
          items: 4,
          nav: true,
        },
        1024: {
          items: 4,
          nav: true,
          loop: false,
        },

        1100: {
          items: 8,
          nav: true,
          loop: false,
        },

        1200: {
          items: 8,
          nav: true,
          loop: false,
        },
        1300: {
          items: 8,
          nav: true,
          loop: false,
        },
        1400: {
          items: 8,
          nav: true,
          loop: false,
        },
        1500: {
          items: 8,
          nav: true,
          loop: false,
        },
      },
    };
  }

  onResize(event) {
    this.resize();

    const width = window.innerWidth || document.body.clientWidth;

    if (width <= 955) {
      this.isMobileView = true;
    } else {
      this.isMobileView = false;
    }
  }

  toggleMobileHeaderSearch() {
    this.isMobileHeaderSearchOpen = !this.isMobileHeaderSearchOpen;
  }

  performMobileHeaderSearch() {
    const q = (this.input || "").trim();
    if (!q) {
      this.isMobileHeaderSearchOpen = false;
      return;
    }
    // Reset and trigger flows search by default
    this.isSearchByFlows = true;
    this.isSearchByUsers = false;
    this.isSearchByBundle = false;
    localStorage.removeItem("pageIndex");
    localStorage.setItem("pageIndex", "0");
    this.performSearch(0);
    this.isMobileHeaderSearchOpen = false;
  }

  flowByCategory(itemCategory) {
    this.tempUsers = [];
    this.itemsRequired = false;
    this.isSearchByFlows = false;
    this.isSearchByUsers = false;
    this.isSearchByBundle = false;
    this.selectedcategory = itemCategory;
    this.setallgray(itemCategory);

    // Keep URL in sync so the header can detect Items tab
    // (header chip UI is enabled when category=Items).
    const headerCategory =
      itemCategory === "Items Required" ? "Items" : itemCategory;
    this.syncCategoryQueryParam(headerCategory);

    if (itemCategory == "All" || itemCategory == "Items Required") {
      this.noResultReturned = true;
      if (itemCategory == "Items Required") {
        this.itemsRequired = true;
        this.isSearchByFlows = true; // render in flows grid for items required
        this.isLoadingFlows = true;
        this.tempFlows = [];
        this.allFlowsLoaded = false;
        this.searchItemsRequired(0);
      } else {
        this.isSearchByFlows = true;
        this.isLoadingFlows = true;
        this.tempFlows = [];
        this.allFlowsLoaded = false;
        this.searchFlows(0);
      }
    } else {
      this.isSearchByFlows = true;
      localStorage.removeItem("categoryPageIndex");
      localStorage.setItem("categoryPageIndex", "0");
      this.noResultReturned = true;

      if (this.input != "" && this.input != undefined) {
        this.isLoadingFlows = true;
        this.tempFlows = [];
        this.allFlowsLoaded = false;
        this.searchFlows(0);
      } else {
        this.email = "";

        if (this.userData != null) {
          this.email = this.userData.emailAddress;
        }
        this.isLoadingFlows = true;
        this.tempFlows = [];
        this.allFlowsLoaded = false;
        this.flowServiceService
          .getFlowsByInputCategory(this.email, itemCategory, "0")
          .subscribe((data) => {
            this.noResultReturned = false;
            this.isLoadingFlows = false;
            if (data.Flows && data.Flows.length > 0) {
              data.Flows.forEach((element) => {
                this.tempFlows.push(element);
              });
              this.allFlowsLoaded = false;
            } else {
              this.allFlowsLoaded = true;
            }
          });
      }
    }
  }

  filteredUsers() {}

  flowsbyItemsRequired(pageIndex) {
    this.email = "";

    if (this.userData != null) {
      this.email = this.userData.emailAddress;
    }

    var flowQueryModel = new FlowQueryModel({
      category: this.selectedcategory,
      searchString: this.input,
      userEmail: this.email,
      pageIndex: pageIndex,
    });

    this.flowServiceService
      .getFlowsByItemsRequired(flowQueryModel)
      .subscribe((data) => {
        this.noResultReturned = false;
        this.noAllResultReturned = false;
        this.isLoadingFlows = false;
        this.isLoadingMore = false;

        if (pageIndex === 0) {
          this.tempFlows = [];
        }

        if (data.flows.length > 0) {
          data.flows.forEach((element) => {
            this.tempFlows.push(element);
          });
          this.allFlowsLoaded = false;
        } else {
          this.allFlowsLoaded = true;
        }
        this.scheduleRetranslate();
      });
  }

  searchItemsRequired(pageIndex) {
    let flows = [];

    this.noResultReturned = true;

    if (pageIndex === 0) {
      this.allFlowsLoaded = false;
    }

    if (this.input !== "" && this.input !== undefined) {
      this.performItemsRequiredSearch(pageIndex);
    } else {
      this.flowsbyItemsRequired(pageIndex);
    }
  }

  searchedItemsRequiredFlows() {
    this.searchItemsRequiredTerms.next(this.input);
  }

  searchedFlows() {
    this.searchTerms.next(this.input);
  }

  // User-scoped filter helpers
  setUserFilter(email: string) {
    this.otherUserEmail = (email || "").trim();
    localStorage.removeItem("pageIndex");
    localStorage.setItem("pageIndex", "0");
    const currentCategory = this.selectedcategory || "All";
    if (currentCategory === "Users") {
      this.performUsersSearch(0);
    } else if (currentCategory === "Bundles") {
      this.performBundleSearch(0);
    } else if (currentCategory === "Items Required") {
      this.performItemsRequiredSearch(0);
    } else {
      this.performSearch(0);
    }
  }

  clearUserFilter() {
    this.setUserFilter("");
  }

  openDialog() {
    if (this.userData != null) {
      this.add_circle_outlinebgColor = "white";
      this.add_circle_outlineColor = "#5ea1d8 !important";
      this.add_circle_outlineSize = "30px";
      localStorage.removeItem("ItemsRequired");
      localStorage.removeItem("flowCoverPageDetails");
      localStorage.removeItem("SupportingDocumentDocuments");
      localStorage.removeItem("SupportingDocumentHyperLinksRequired");
      localStorage.removeItem("stepsCoverPageDetails");
      localStorage.removeItem("draftWord");
      localStorage.removeItem("editWord");
      const dialogRef = this.dialog.open(BundledialogComponent, {
        panelClass: "dialoguebox",
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result == "bundle") {
          localStorage.setItem(
            "navigatebackfromcreatebundle",
            this.location.path()
          );
          localStorage.removeItem("createbundledetails");
          localStorage.removeItem("addbundleselectedflows");
          this.router.navigate(["/create-guide-pack"]);
        } else if (result === "flow") {
          localStorage.setItem(
            "navigatebackfromcreateflow",
            this.location.path()
          );
          this.router.navigate(["/create-guide"]);
        } else {
          this.eventEmitterService.setUserProfileCreateIconClickedEvent("");
          this.add_circle_outlinebgColor = "white";
          this.add_circle_outlineColor = "#212427 !important"; //window.location.reload();
        }
      });
    } else {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
    }
  }

  searchFlows(pageIndex): any {
    this.noAllResultReturned = true;
    this.noResultReturned = true;
    this.email = "";

    if (this.userData != null) {
      this.email = this.userData.emailAddress;
    }

    var flowQueryModel = new FlowQueryModel({
      category: this.selectedcategory,
      searchString: this.input,
      userEmail: this.email,
      otherUserEmail: this.otherUserEmail,
      pageIndex: pageIndex,
    });

    if (this.input !== "" && this.input !== undefined) {
      this.performSearch(pageIndex);
    } else {
      this.flowServiceService
        .getSearchApprovedFlowsByFlowQueryModel(flowQueryModel)
        .subscribe((data) => {
          console.log(data);
          this.noResultReturned = false;
          this.noAllResultReturned = false;
          this.isLoadingFlows = false;
          this.isLoadingMore = false;

          if (pageIndex === 0) {
            this.tempFlows = [];
          }

          const flows = data?.flows || [];
          this.lastFlowsPageSize = flows.length;

          if (flows.length > 0) {
            // Append all approved flows; show full result set
            flows.forEach((element) => {
              this.tempFlows.push(element);
            });
            // Stop further scroll when fewer than pageSize are returned
            this.allFlowsLoaded = this.lastFlowsPageSize < this.pageSize;
          } else {
            this.allFlowsLoaded = true;
          }
          this.account_circle = "account_circle";
          this.scheduleRetranslate();
        });
    }
  }

  searchUsers(category) {
    this.searchTermsUsers.next(category);
  }

  setallgray(selectedCategory) {
    this.allFlowsbgColor = "white";
    this.allFlowsColor = "gray";

    this.userbgColor = "white";
    this.userColor = "gray";

    // this.automobilesbgColor = "white";
    // this.automobilesColor = "gray";

    // this.adventuresbgColor = "white";
    // this.adventuresColor = "gray";

    // this.artandCraftbgColor = "white";
    // this.artandCraftColor = "gray";

    // this.beautybgColor = "white";
    // this.beautyColor = "gray";

    // this.fashionbgColor = "white";
    // this.fashionColor = "gray";

    // this.fitnessbgColor = "white";
    // this.fitnessColor = "gray";

    // this.homeandbgGardenColor = "white";
    // this.homeandGardenColor = "gray";

    // this.metalbgworksColor = "white";
    // this.metalworksColor = "gray";

    // this.photographybgColor = "white";
    // this.photographyColor = "gray";

    // this.recipebgColor = "white";
    // this.recipeColor = "gray";

    // this.technologybgColor = "white";
    // this.technologyColor = "gray";

    // this.woodworksbgColor = "white";
    // this.woodworksColor = "gray";

    this.itemsRequiredbgColor = "white";
    this.itemsRequiredColor = "gray";

    this.bundlesbgColor = "white";
    this.bundlesColor = "gray";

    // this.gamesbgColor = "white";
    // this.gamesColor = "gray";

    // this.entertainmentbgColor = "white";
    // this.entertainmentColor = "gray";

    this.setSelectedCategoryToBlack(selectedCategory);
  }

  setSelectedCategoryToBlack(selectedCategory) {
    this.itemsRequired = false;
    switch (selectedCategory) {
      case "All":
        this.allFlowsbgColor = "gray";
        this.allFlowsColor = "white";
        break;
      case "Users":
        this.userbgColor = "gray";
        this.userColor = "white";
        break;
      // case "Adventures":
      //   this.adventuresbgColor = "gray";
      //   this.adventuresColor = "white";
      //   break;
      // case "Art & Craft":
      //   this.artandCraftbgColor = "gray";
      //   this.artandCraftColor = "white";
      //   break;
      // case "Automobiles":
      //   this.automobilesbgColor = "gray";
      //   this.automobilesColor = "white";
      //   break;
      // case "Beauty":
      //   this.beautybgColor = "gray";
      //   this.beautyColor = "white";
      //   break;
      // case "Fashion":
      //   this.fashionbgColor = "gray";
      //   this.fashionColor = "white";
      //   break;
      // case "Fitness":
      //   this.fitnessColor = "white";
      //   this.fitnessbgColor = "gray";
      //   break;
      // case "Home Improvements":
      //   this.homeandGardenColor = "white";
      //   this.homeandbgGardenColor = "gray";
      //   break;
      // case "Media Production":
      //   this.photographyColor = "white";
      //   this.photographybgColor = "gray";
      //   break;
      // case "Beauty":
      //   this.beautybgColor = "gray";
      //   this.beautyColor = "white";
      //   break;
      // case "Entertainment":
      //   this.entertainmentbgColor = "gray";
      //   this.entertainmentColor = "white";
      //   break;
      // case "Games":
      //   this.gamesbgColor = "gray";
      //   this.gamesColor = "white";
      //   break;
      // case "Metalworks":
      //   this.metalbgworksColor = "gray";
      //   this.metalworksColor = "white";
      //   break;
      // case "Recipe":
      //   this.recipebgColor = "gray";
      //   this.recipeColor = "white";
      //   break;
      // case "Technology":
      //   this.technologybgColor = "gray";
      //   this.technologyColor = "white";
      //   break;
      // case "Woodworks":
      //   this.woodworksColor = "white";
      //   this.woodworksbgColor = "gray";
      //   break;
      case "Items Required":
        this.itemsRequired = true;
        this.itemsRequiredColor = "white";
        this.itemsRequiredbgColor = "gray";
        break;
      case "Bundles":
        this.bundlesColor = "white";
        this.bundlesbgColor = "gray";
        break;
    }
  }

  viewUserProfile(selectedFlow) {
    console.log(selectedFlow);
    this.syncAuthFromStorage();
    if (this.userData != null) {
      if (
        this.userData.emailAddress === selectedFlow.customerEmail ||
        this.userData.emailAddress === selectedFlow.emailAddress
      ) {
        this.router.navigate(["/user-profile"]);
      } else if (selectedFlow.userName) {
        this.router.navigate(["/view-profile", selectedFlow.userName.replace(/^@/, '')]);
      } else {
        this.dataService.flowByCategorieschangeMessage(selectedFlow);
        this.router.navigate(["/view-profile"]);
      }
    } else {
      // this.dataService.flowByCategorieschangeMessage(selectedFlow);
            // Open sign up modal (similar to about us page)
      this.authModalService.openModal('registration');
    }
  }

  viewCoAuthorProfile(item: any, event: Event): void {
    event.stopPropagation();
    this.syncAuthFromStorage();
    if (!item.coAuthorEmail) return;
    if (this.userData?.emailAddress === item.coAuthorEmail) {
      this.router.navigate(['/user-profile']);
    } else if (item.coAuthorUserName) {
      this.router.navigate(['/view-profile', item.coAuthorUserName.replace(/^@/, '')]);
    } else {
      this.dataService.flowByCategorieschangeMessage({ customerEmail: item.coAuthorEmail });
      this.router.navigate(['/view-profile']);
    }
  }

  /** Item whose collaborators popup is currently open (null = closed). */
  collabPopupItem: any = null;
  collabPopupCoAuthors: { email: string; userName: string; profilePicUrl: string }[] = [];

  showCollabPopup(item: any, event: Event): void {
    event.stopPropagation();
    this.collabPopupItem = this.collabPopupItem === item ? null : item;
    this.collabPopupCoAuthors = this.collabPopupItem ? this.getCollabCoAuthors(this.collabPopupItem) : [];
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.collabPopupItem = null;
    this.collabPopupCoAuthors = [];
  }

  navigateToUserFromPopup(item: any, isCoAuthor: boolean, event: Event): void {
    event.stopPropagation();
    this.collabPopupItem = null;
    if (isCoAuthor) {
      this.viewCoAuthorProfile(item, event);
    } else {
      this.viewUserProfile(item);
    }
  }

  isCollabFlow(item: any): boolean {
    if (!(item?.isCollaboration || item?.IsCollaboration)) return false;
    if (!(item?.coAuthorEmail || item?.CoAuthorEmail)) return false;
    // Check per-person statuses first (array wins over single status)
    const statusesRaw = item?.coAuthorStatuses || item?.CoAuthorStatuses || null;
    if (statusesRaw) {
      try {
        const statuses: string[] = JSON.parse(statusesRaw);
        return statuses.some(s => s === 'Accepted');
      } catch {}
    }
    // Fall back to single collaborationStatus field
    const status = item?.collaborationStatus || item?.CollaborationStatus || '';
    return status === 'Accepted';
  }

  /** Returns the first accepted co-author's username for the "and @username" text on flow cards. */
  coAuthorDisplay(item: any): string {
    const accepted = this.getCollabCoAuthors(item);
    return accepted.length > 0 ? accepted[0].userName : '';
  }

  getCollabCoAuthors(item: any): { email: string; userName: string; profilePicUrl: string }[] {
    if (!item) return [];
    const coAuthorEmail     = item.coAuthorEmail    || item.CoAuthorEmail    || null;
    const coAuthorUserName  = item.coAuthorUserName || item.CoAuthorUserName || null;
    const coAuthorPicUrl    = item.coAuthorProfilePicUrl || item.CoAuthorProfilePicUrl || null;
    const coAuthorEmails    = item.coAuthorEmails    || item.CoAuthorEmails    || null;
    const coAuthorUserNames = item.coAuthorUserNames || item.CoAuthorUserNames || null;
    const coAuthorPicUrls   = item.coAuthorProfilePicUrls || item.CoAuthorProfilePicUrls || null;
    const coAuthorStatuses  = item.coAuthorStatuses  || item.CoAuthorStatuses  || null;
    let emails: string[] = [];
    let userNames: string[] = [];
    let profilePicUrls: string[] = [];
    let statuses: string[] = [];
    try { if (coAuthorEmails) emails = JSON.parse(coAuthorEmails); } catch {}
    try { if (coAuthorUserNames) userNames = JSON.parse(coAuthorUserNames); } catch {}
    try { if (coAuthorPicUrls) profilePicUrls = JSON.parse(coAuthorPicUrls); } catch {}
    try { if (coAuthorStatuses) statuses = JSON.parse(coAuthorStatuses); } catch {}
    const singleStatus = item?.collaborationStatus || item?.CollaborationStatus || '';
    if (Array.isArray(emails) && emails.length > 0) {
      return emails
        .map((email, i) => ({
          email,
          userName: userNames[i] || (i === 0 ? coAuthorUserName : '') || email,
          profilePicUrl: profilePicUrls[i] || (i === 0 ? coAuthorPicUrl : '') || '',
          status: statuses[i] || singleStatus,
        }))
        .filter(c => c.status === 'Accepted');
    }
    if (coAuthorEmail && singleStatus === 'Accepted') {
      return [{ email: coAuthorEmail, userName: coAuthorUserName || coAuthorEmail, profilePicUrl: coAuthorPicUrl || '' }];
    }
    return [];
  }

  getExtraCollabCount(item: any): number {
    return Math.max(0, this.getCollabCoAuthors(item).length - 1);
  }

  navigateToCoAuthorProfile(coAuthor: { email: string; userName: string; profilePicUrl: string }, event: Event): void {
    event.stopPropagation();
    this.collabPopupItem = null;
    this.collabPopupCoAuthors = [];
    const syntheticItem = { coAuthorEmail: coAuthor.email, coAuthorUserName: coAuthor.userName };
    this.viewCoAuthorProfile(syntheticItem, event);
  }

  CheckIsUserFollowing(user) {
    if (this.userData != null) {
      if (this.userData.emailAddress === user.user.emailAddress) {
        user.showFollow = false;
      } else {
        user.showFollow = true;

        const flowModel = {
          CustomerEmail: user.user.emailAddress,
          UserEmailAddress: this.userData.emailAddress,
        };

        this.flowServiceService
          .CheckIsUserFollowing(flowModel)
          .subscribe((data) => {
            if (data.MessageText === "Following") {
              user.followButtonText = "Following";
              user.followingcolor = "black";
              user.followingbgcolor = "white";
            } else {
              user.followButtonText = "Follow";
              user.followingcolor = "white";
              user.followingbgcolor = "#5ea1d8";
            }
          });
      }
    }
  }

  followUser(selectedUser) {
    if (this.userData != null) {
      //
      let user = this.tempUsers.filter(
        (u) => u.user.emailAddress == selectedUser.emailAddress
      )[0];
      if (user?.isFollowLoading) {
        return;
      }
      if (user) {
        user.isFollowLoading = true;
      }

      const flowModel = {
        UserEmail: selectedUser.emailAddress,
        FollowerEmail: this.userData.emailAddress,
      };

      this.flowServiceService.FollowUser(flowModel).subscribe((data) => {
        user = this.tempUsers.filter(
          (u) => u.user.emailAddress == selectedUser.emailAddress
        )[0];
        if (user) {
          user.isFollowLoading = false;
        }

        if (data.isFollowing === "following") {
          user.followButtonText = "Following";
          user.followingcolor = "black";
          user.followingbgcolor = "white";
        } else {
          user.followButtonText = "Follow";
          user.followingcolor = "white";
          user.followingbgcolor = "#5ea1d8";
        }
        this.changeDetectorRef.detectChanges();
      }, () => {
        user = this.tempUsers.filter(
          (u) => u.user.emailAddress == selectedUser.emailAddress
        )[0];
        if (user) {
          user.isFollowLoading = false;
        }
        this.changeDetectorRef.detectChanges();
      });
    } else {
      // Show login modal instead of full-page navigation
      this.authModalService.openModal('login', this.router.url);
    }
  }

  getAllUsers(itemcategory) {
    this.itemsRequired = false;
    localStorage.removeItem("searchuserpageIndex");
    localStorage.setItem("searchuserpageIndex", "0");
    this.selectedcategory = itemcategory;
    if (this.orgModeOnly) {
      this.orgSelectedCategory = "Users";
    }
    this.syncCategoryQueryParam("Users");

    if (itemcategory != "All") {
      this.isSearchByFlows = false;
      this.isSearchByUsers = true;
      this.isSearchByBundle = false;
    }

    this.setallgray(itemcategory);
    this.allFlowsLoaded = false;
    this.isLoadingFlows = true;
    this.allUsers = [];
    this.tempUsers = [];
    this.changeDetectorRef.detectChanges();
    this.getPaginatedUsers(undefined, "0");
  }

  getPaginatedUsers(infiniteScroll, pageIndex) {
    if (this.orgModeOnly && this.orgContextService.canViewUsersTab()) {
      this.isLoadingFlows = true;
      this.loadOrgMembers(pageIndex);
      return;
    }

    var email = "";
    if (this.userData != null && this.userData != undefined) {
      email = this.userData.emailAddress;
    }

    var flowQueryModel = new FlowQueryModel({
      category: this.selectedcategory,
      searchString: this.input,
      userEmail: email,
      pageIndex: pageIndex,
    });

    if (this.input !== "" && this.input !== undefined) {
      this.isLoadingFlows = true;
      this.performUsersSearch(pageIndex);
    } else {
      this.isLoadingFlows = true;
      this.userserviceService.getAllUsers(flowQueryModel).subscribe((data) => {
        this.isLoadingFlows = false;
        this.isLoadingMore = false;
        if (data?.allUsers?.length > 0) {
          this.tempUsers = [];
          data.allUsers.forEach((element) => {
            normalizeUserProfilePic(element);
            const user = {
              user: element,
              showFollow: false,
              followButtonText: element.followingText,
            };
            this.allUsers.push(user);
          });
          this.tempUsers = this.allUsers;
          this.tempUsers.forEach((element) => {
            if (element.followButtonText === "Following") {
              element.followButtonText = "Following";
              element.followingcolor = "black";
              element.followingbgcolor = "white";
            } else {
              element.followButtonText = "Follow";
              element.followingcolor = "white";
              element.followingbgcolor = "#5ea1d8";
            }
          });
          this.allFlowsLoaded = false;
        } else {
          this.allFlowsLoaded = true;
        }
        this.changeDetectorRef.detectChanges();
      });
    }
  }

  getFlows(): any {
    this.flows = [];
    this.noResultReturned = true;
    this.isSearchByFlows = true;
    this.isSearchByUsers = false;
    this.isSearchByBundle = false;
    this.selectedcategory = "All";
    localStorage.removeItem("pageIndex");
    localStorage.setItem("pageIndex", "0");
    this.searchFlows(0);
  }

  delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  onScroll(event: MouseEvent) {
    this.noResultReturned = true;
    // Use debounced scroll handler; actual loading happens in delayedServiceCall
    this.scrollSubject.next(event);
  }

  delayedServiceCall() {
    // Prevent extra API calls when already loading or when all results are loaded
    if (this.isLoadingFlows || this.isLoadingMore || this.allFlowsLoaded) {
      return;
    }

    this.isLoadingMore = true;
    this.email = "";

    if (this.userData != null) {
      this.email = this.userData.emailAddress;
    }
    if (this.selectedcategory == "All") {
      var pageIndex = localStorage.getItem("pageIndex");
      pageIndex = (parseInt(pageIndex) + 1).toString();
      localStorage.setItem("pageIndex", pageIndex);
      this.searchFlows(pageIndex);
    } else {
      var pageIndex = localStorage.getItem("categoryPageIndex");
      pageIndex = (parseInt(pageIndex) + 1).toString();
      localStorage.setItem("categoryPageIndex", pageIndex);
      if (
        this.selectedcategory == "Items Required" &&
        this.input != "" &&
        this.input != undefined
      ) {
        console.log("scroll");
        var pageIndex = localStorage.getItem("pageIndex");
        pageIndex = (parseInt(pageIndex) + 1).toString();
        localStorage.setItem("pageIndex", pageIndex);
        this.itemsRequired = true;
        this.performItemsRequiredSearch(pageIndex);
      } else if (this.selectedcategory == "Bundles") {
        this.searchBundleFlows(parseInt(pageIndex));
      } else if (this.selectedcategory == "Users") {
        this.noResultReturned = false;
        pageIndex = localStorage.getItem("searchuserpageIndex");
        pageIndex = (parseInt(pageIndex) + 1).toString();
        localStorage.setItem("searchuserpageIndex", pageIndex);
        this.getPaginatedUsers(undefined, pageIndex);
      } else {
        this.flowsbyItemsRequired(pageIndex);
      }
    }
  }

  searchBundleFlows(pageIndex: number) {
    this.noResultReturned = true;
    this.noAllResultReturned = true;

    if (pageIndex === 0) {
      this.allFlowsLoaded = false;
    }

    this.email = "";

    if (this.userData != null) {
      this.email = this.userData.emailAddress;
    }

    var flowQueryModel = new FlowQueryModel({
      category: this.selectedcategory,
      searchString: this.input,
      userEmail: this.email,
      otherUserEmail: this.otherUserEmail,
      pageIndex: pageIndex,
    });

    if (this.input !== "" && this.input !== undefined) {
      this.performBundleSearch(pageIndex);
    } else {
      this.flowServiceService
        .getSearchApprovedBundleByBundleQueryModel(flowQueryModel)
        .subscribe((data) => {
          this.noResultReturned = false;
          this.noAllResultReturned = false;
          this.isLoadingFlows = false;
          this.isLoadingMore = false;

          if (pageIndex === 0) {
            this.tempFlows = [];
          }

          if (
            data.flows != null &&
            data.flows != undefined &&
            data.flows.length > 0
          ) {
            data.flows.forEach((element) => {
              this.tempFlows.push(element);
            });
            this.allFlowsLoaded = false;
          } else {
            this.allFlowsLoaded = true;
          }
          this.scheduleRetranslate();
        });
    }
  }

  private syncAuthFromStorage(loggedIn?: boolean): void {
    if (loggedIn === false) {
      this.userData = null;
      this.isUserLoggedIn = false;
      this.userDisplayName = null;
      this.userDisplayEmail = null;
      this.changeDetectorRef.detectChanges();
      return;
    }

    const raw = localStorage.getItem("LoggedInUser");
    if (!raw || raw === "null") {
      this.userData = null;
      this.isUserLoggedIn = false;
      return;
    }

    try {
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== "object") {
        this.userData = null;
        this.isUserLoggedIn = false;
        return;
      }
      this.userData = parsed;
      this.isUserLoggedIn = true;
      this.userDisplayName = parsed.firstName;
      this.userDisplayEmail = parsed.emailAddress;
      this.changeDetectorRef.detectChanges();
    } catch {
      this.userData = null;
      this.isUserLoggedIn = false;
    }
  }

  flowClicked(flow) {
    this.syncAuthFromStorage();
    // Check if user is logged in
    if (!this.userData || this.userData === null) {
      // Store flow data to navigate after sign in
      localStorage.setItem("checkoutFlow", JSON.stringify(flow));
      localStorage.setItem("returnUrl", this.router.url);
      // Open sign up modal (similar to about us page)
      this.authModalService.openModal('registration');
      return;
    }

    localStorage.setItem("flow", JSON.stringify(flow));
    localStorage.setItem("notificationflowId", null);
    localStorage.setItem("navigateTo", "search");
    if (this.selectedcategory == "Bundles") {
      this.router.navigate(["/view-guide-pack/" + flow.rowKey]);
    } else {
      this.router.navigate([
        `/guide/${this.generateUrlSlug(flow.title)}/${flow.rowKey.toString()}`,
      ]);
    }
  }

  generateUrlSlug(html) {
    if (!html) return "";
    return html
      .replace(/<[^>]*>/g, "") // Remove HTML tags
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove accents (é → e, ñ → n)
      .replace(/[^a-zA-Z0-9\s-]/g, "") // Remove special characters except spaces and "-"
      .trim() // Trim spaces from start/end
      .replace(/\s+/g, "-") // Replace spaces with "-"
      .replace(/-+/g, "-") // Remove duplicate dashes
      .toLowerCase(); // Convert to lowercase
  }

  showImage(itemCategory, item, index) {
    itemCategory.flowModels.forEach((element) => {
      if (element.arrow !== undefined) {
        element.arrow = false;
      }
    });
    if (!itemCategory.showImg || index !== this.previousIndex) {
      this.currentImage = item.Url;
      this.previousIndex = index;
      itemCategory.showImg = true;
      item.arrow = true;
    } else {
      itemCategory.showImg = false;
      item.arrow = false;
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  getAllBundles(itemCategory) {
    this.tempUsers = [];
    this.isSearchByBundle = true;
    this.itemsRequired = false;
    this.isSearchByFlows = false;
    this.isSearchByUsers = false;
    this.selectedcategory = itemCategory;
    this.setallgray(itemCategory);
    this.syncCategoryQueryParam("Bundles");
    localStorage.removeItem("categoryPageIndex");
    localStorage.setItem("categoryPageIndex", "0");
    this.noResultReturned = true;
    this.isLoadingFlows = true;
    this.tempFlows = [];
    this.allFlowsLoaded = false;
    this.searchBundleFlows(0);
  }

  getBundles(itemCategory, pageIndex) {
    this.bundleService
      .getBundles("", itemCategory, pageIndex)
      .subscribe((data) => {
        this.noResultReturned = false;
        data.Bundles.forEach((element) => {
          this.tempFlows.push(element);
        });
        this.scheduleRetranslate();
      });
  }

  timeAgo(createdDate: string): string {
    const currentTime = new Date();
    const notificationTime = new Date(createdDate);

    // Check if the date is valid
    if (isNaN(notificationTime.getTime())) {
      console.warn("Invalid date provided to timeAgo:", createdDate);
      return "Unknown time";
    }

    const timeDifference = currentTime.getTime() - notificationTime.getTime(); // Difference in milliseconds

    // Handle negative time differences (future dates)
    if (timeDifference < 0) {
      return "Just now";
    }

    // Convert time difference to different time units
    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30); // Rough approximation of months
    const years = Math.floor(days / 365); // Rough approximation of years

    if (years > 0) {
      return `${years} year${years > 1 ? "s" : ""} ago`;
    } else if (months > 0) {
      return `${months} month${months > 1 ? "s" : ""} ago`;
    } else if (weeks > 0) {
      return `${weeks} week${weeks > 1 ? "s" : ""} ago`;
    } else if (days > 0) {
      return `${days} day${days > 1 ? "s" : ""} ago`;
    } else if (hours > 0) {
      return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    } else if (minutes > 0) {
      return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    } else {
      return `${seconds} second${seconds > 1 ? "s" : ""} ago`;
    }
  }
  parseCreatedDate = (createdDate) => {
    const currentDate = new Date();

    const [value, unit] = createdDate.split(" ");

    switch (unit) {
      case "minutes":
      case "minute":
        currentDate.setMinutes(currentDate.getMinutes() - parseInt(value));
        break;
      case "hours":
      case "hour":
        currentDate.setHours(currentDate.getHours() - parseInt(value));
        break;
      case "days":
      case "day":
        currentDate.setDate(currentDate.getDate() - parseInt(value));
        break;
      case "weeks":
      case "week":
        currentDate.setDate(currentDate.getDate() - parseInt(value) * 7);
        break;
      default:
        console.log("Unhandled unit: " + unit);
    }

    return currentDate.toISOString(); // Returns timestamp in ISO format
  };

  getnotification() {
    this.noResultReturned = true;
    this.notificationsarray = []; // Clear existing notifications

    var flowQueryModel = new FlowQueryModel({
      userEmail: this.userData.emailAddress,
      pageIndex: 0,
    });

    this.flowServiceService
      .getNotifications(flowQueryModel)
      .subscribe((data) => {
        this.isthereanyNotifications = true;
        this.noResultReturned = false;
        //
        if (data != null) {
          data.forEach((element) => {
            console.log(element);
            if (!this.orgContextService.isNotificationVisible(element)) {
              return;
            }
            var notification = {
              notification: {
                CreatedDate: this.timeAgo(element.createdDate),
                OriginalCreatedDate: element.createdDate, // Store original date for proper sorting
                ProfilePicUrl: element.notifierProfilePicUrl,
                NotifierUserName: element.notifierUserName,
                NotificationSeen: element.notificationSeen,
                Message: element.message,
                ContentId: element.contentId,
                ContentTitle: element.contentTitle,
                FlowUrl: element.flowUrl,
                FlowId: element.notifierCustomerId,
                ContentType: element.contentType,
                ConsultationNavTarget: element.consultationNavTarget,
                NotifierUserEmail: element.notifierUserEmail,
                VideoFlowPosterImageUrl: element.videoFlowPosterImageUrl,
                OrganizationId: element.organizationId,
                NavigationUrl: element.navigationUrl,
                PartitionKey: element.partitionKey,
                RowKey: element.rowKey,
              },
            };
            console.log(notification);
            this.notificationsarray.push(notification);
          });

          // Sort notifications by actual date (newest first) before categorization
          this.notificationsarray.sort((a, b) => {
            const dateA = this.parseRelativeTime(a.notification.CreatedDate);
            const dateB = this.parseRelativeTime(b.notification.CreatedDate);
            return dateB.getTime() - dateA.getTime(); // Newest first
          });

          this.categorizeNotifications();
          this.notificationscount = this.notificationsarray.filter(
            (notification) => !notification.notification.NotificationSeen
          ).length;
          if (this.notificationscount > 0) {
            this.showNotificationCount = true;
          } else {
            this.showNotificationCount = false;
          }
          console.log(this.notificationscount);
          console.log(this.notificationsarray);
        } else {
          this.isthereanyNotifications = false;
        }
      });
  }
  scheduleReadNotification(): void {
    // Use a delay of 1 minute 30 seconds (90,000 milliseconds) before calling ReadNotification
    setTimeout(() => {
      this.ReadNotification();
    }, 90000); // 90 seconds delay
  }

  categorizeNotifications() {
    this.notificationsToday = this.notificationsarray.filter((notification) =>
      this.isToday(
        this.parseRelativeTime(notification.notification.CreatedDate)
      )
    );
    console.log(this.notificationsToday);

    this.notificationsYesterday = this.notificationsarray.filter(
      (notification) =>
        this.isYesterday(
          this.parseRelativeTime(notification.notification.CreatedDate)
        )
    );
    console.log(this.notificationsYesterday);

    this.notificationsThisWeek = this.notificationsarray.filter(
      (notification) => {
        const notificationDate = this.parseRelativeTime(
          notification.notification.CreatedDate
        );
        return (
          this.isThisWeek(notificationDate) &&
          !this.isToday(notificationDate) &&
          !this.isYesterday(notificationDate)
        );
      }
    );
    console.log(this.notificationsThisWeek);

    this.notificationsOlder = this.notificationsarray.filter((notification) => {
      const notificationDate = this.parseRelativeTime(
        notification.notification.CreatedDate
      );
      return (
        this.isOlder(notificationDate) && !this.isThisWeek(notificationDate)
      );
    });
    console.log(this.notificationsOlder);
  }

  parseRelativeTime(relativeTime: string): Date {
    const time = new Date();
    const numberPattern = /\d+/g;
    const value = parseInt(relativeTime.match(numberPattern)?.[0] || "0", 10);

    // Handle different time units
    if (relativeTime.includes("second")) {
      time.setSeconds(time.getSeconds() - value);
    } else if (relativeTime.includes("minute")) {
      time.setMinutes(time.getMinutes() - value);
    } else if (relativeTime.includes("hour")) {
      time.setHours(time.getHours() - value);
    } else if (relativeTime.includes("day")) {
      time.setDate(time.getDate() - value);
    } else if (relativeTime.includes("week")) {
      time.setDate(time.getDate() - value * 7);
    } else if (relativeTime.includes("month")) {
      time.setMonth(time.getMonth() - value);
    } else if (relativeTime.includes("year")) {
      time.setFullYear(time.getFullYear() - value);
    } else {
      // If we can't parse the relative time, try to parse as ISO date
      try {
        const parsedDate = new Date(relativeTime);
        if (!isNaN(parsedDate.getTime())) {
          return parsedDate;
        }
      } catch (e) {
        console.warn("Could not parse date:", relativeTime);
      }
      // Fallback to current time if parsing fails
      return new Date();
    }

    return time;
  }

  isToday(date: Date): boolean {
    return date.toDateString() === this.today.toDateString();
  }

  isYesterday(date: Date): boolean {
    return date.toDateString() === this.yesterday.toDateString();
  }

  isThisWeek(date: Date): boolean {
    return date > this.thisWeekStart && date <= this.today;
  }

  isOlder(date: Date): boolean {
    return date < this.thisWeekStart;
  }

  toggleSidebar(): void {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }

  homePage(): void {
    this.router.navigate(["/"]);
  }

  userdashboard(): void {
    this.router.navigate(["/user-dashboard"]);
  }

  SignOut(): void {
    localStorage.removeItem("LoggedInUser");
    localStorage.setItem("isLogin", "No");
    this.syncAuthFromStorage(false);
    this.profilePicture = null;
    this.router.navigate(["/"]);
  }

  ReadNotification(): void {
    const transformedNotifications = this.notificationsarray.map((item) => {
      const notification = item.notification;
      return {
        ...notification,
        CreatedDate: this.parseCreatedDate(notification.CreatedDate),
      };
    });
    console.log(transformedNotifications);
    this.noResultReturned = true;
    console.log(this.noResultReturned);
    console.log(this.notificationsarray);
    this.flowServiceService
      .MarkAsReadNotifications(transformedNotifications)
      .subscribe((data) => {
        this.isthereanyNotifications = true;
        this.noResultReturned = false;

        if (data != null) {
          console.log("success");
        } else {
          this.isthereanyNotifications = false;
        }
      });
  }

  // Share and Save Flow Functions
  shareFlow(item: any): void {
    if (!item) {
      return;
    }

    if (this.isBundleItem(item)) {
      this.shareBundle(item);
    } else {
      this.shareFlowContent(item);
    }
  }

  saveFlow(item: any): void {
    this.syncAuthFromStorage();
    if (!this.userData) {
          // Open sign up modal (similar to about us page)
      this.authModalService.openModal('registration');
      return;
    }

    const flowId = this.getItemIdentifier(item);

    if (!flowId) {
      this.toastr.error("Unable to update save status right now");
      return;
    }

    const isBundle = this.isBundleItem(item);
    const flowModel = {
      UserEmail: this.userData.emailAddress,
      FlowId: flowId,
      FlowType: isBundle ? 2 : 1,
    };

    this.flowServiceService.postBookMarkFlow(flowModel).subscribe(
      (data) => {
        if (data?.bookMarked === "bookmarked") {
          item.isSaved = true;
          item.bookmarkColor = "#5ea1d8";
          this.toastr.success(isBundle ? "Bundle Saved" : "Flow Saved");
        } else if (data?.bookMarked === "bookmarkremoved") {
          item.isSaved = false;
          item.bookmarkColor = "#666666";
          this.toastr.success(isBundle ? "Bundle Unsaved" : "Flow Unsaved");
        } else {
          this.toastr.error("Unable to update save status");
        }
      },
      (error) => {
        console.error("Error saving flow:", error);
        this.toastr.error("Failed to save flow");
      }
    );
  }

  isFlowSaved(item: any): boolean {
    return item.isSaved === true;
  }

  getBookmarkColor(item: any): string {
    if (item?.bookmarkColor) {
      return item.bookmarkColor;
    }
    return this.isFlowSaved(item) ? "#5ea1d8" : "#666666";
  }

  private isBundleItem(item: any): boolean {
    const type = (item?.type || item?.Type || "").toString().toLowerCase();
    return type === "bundle";
  }

  private getItemIdentifier(item: any): string {
    return (
      item?.rowKey ||
      item?.id ||
      item?.flowId ||
      item?.FlowId ||
      item?.contentId ||
      ""
    );
  }

  private shareBundle(item: any): void {
    if (item?.codeToEmbed && item?.url) {
      this.openShareDialog(item, true);
      return;
    }

    const bundleId = this.getItemIdentifier(item);
    if (!bundleId) {
      this.toastr.error("Unable to open share options");
      return;
    }

    const flowQueryModel = new FlowQueryModel({
      BundleId: bundleId,
      userEmail: this.userData?.emailAddress || "",
    });

    this.bundleService.getBundleById(flowQueryModel).subscribe(
      (response) => {
        const bundle = response?.bundleModel || response?.bundle;
        if (bundle) {
          this.openShareDialog(bundle, true);
        } else {
          this.toastr.error("Unable to fetch bundle details for sharing");
        }
      },
      (error) => {
        console.error("Error fetching bundle details for sharing:", error);
        this.toastr.error("Unable to fetch bundle details for sharing");
      }
    );
  }

  private shareFlowContent(item: any): void {
    if (item?.codeToEmbed && item?.url) {
      this.openShareDialog(item, false);
      return;
    }

    const flowId = this.getItemIdentifier(item);
    if (!flowId) {
      this.toastr.error("Unable to open share options");
      return;
    }

    const flowQueryModel = new FlowQueryModel({
      FlowId: flowId,
      userEmail: this.userData?.emailAddress || "",
    });

    this.flowServiceService.getFlowById(flowQueryModel).subscribe(
      (response) => {
        if (response?.flows) {
          this.openShareDialog(response.flows, false);
        } else {
          this.toastr.error("Unable to fetch flow details for sharing");
        }
      },
      (error) => {
        console.error("Error fetching flow details for sharing:", error);
        this.toastr.error("Unable to fetch flow details for sharing");
      }
    );
  }

  private openShareDialog(item: any, isBundle: boolean): void {
    const dialogData: ShareEmbedDialogData = isBundle
      ? {
          contentType: "bundle",
          bundleData: item,
          embedContext: { view: "full" },
        }
      : {
          contentType: "flow",
          flowData: item,
          embedContext: { view: "full" },
        };

    if (isBundle) {
      this.dialog.open(EmbedforbundlesComponent, {
        panelClass: "dialoguebox",
        width: "520px",
        maxWidth: "95vw",
        data: dialogData,
      });
      return;
    }

    this.dialog.open(EmbededComponent, {
      panelClass: "dialoguebox",
      width: "520px",
      maxWidth: "95vw",
      data: dialogData,
    });
  }

  ngOnDestroy(): void {
    this.loginEventSub?.unsubscribe();
    this.accountTypeSub?.unsubscribe();
  }

  /**
   * Home is not re-created when signing in from "/", so once the account type
   * resolves, switch from the public feed to the org library if needed.
   */
  private applyAccountTypeAfterLogin(): void {
    this.accountTypeSub?.unsubscribe();
    this.accountTypeSub = this.orgContextService.load().subscribe(() => {
      if (!this.orgContextService.isOrganizationMode() || this.orgModeOnly) {
        return;
      }
      this.orgModeOnly = true;
      this.orgSelectedCategory = "Guides";
      this.isLoadingOrgLibrary = true;
      this.isLoadingFlows = false;
      this.tempFlows = [];
      this.allFlowsLoaded = true;
      this.changeDetectorRef.detectChanges();
      this.loadOrgLibrary();
    });
  }

  private loadOrgLibrary(): void {
    if (!this.orgContextService.isOrganizationMode()) {
      // Public account mode: do not force org library even if memberships exist.
      const mode = this.orgContextService.snapshot.accountUsageMode;
      const savedMode =
        typeof localStorage !== "undefined"
          ? localStorage.getItem("accountUsageMode")
          : null;
      if (mode === "public" || savedMode === "public") {
        this.orgModeOnly = false;
        this.isLoadingOrgLibrary = false;
        this.orgLibraryItems = [];
        return;
      }
      // Context may still be loading — wait for load() then decide.
    }

    const finish = (ctx: any, id: string) => {
      if (
        this.orgContextService.snapshot.accountUsageMode === "public" ||
        localStorage.getItem("accountUsageMode") === "public"
      ) {
        this.orgModeOnly = false;
        this.isLoadingOrgLibrary = false;
        this.orgLibraryItems = [];
        return;
      }
      this.orgModeOnly = true;
      this.isLoadingOrgLibrary = true;
      this.orgLibraryItems = [];
      this.orgLibraryTitle = ctx?.activeOrganization?.name
        ? `${ctx.activeOrganization.name} library`
        : "Your organization library";
      const appId = this.orgContextService.snapshot.activeApplicationId || undefined;
      const teamId = this.orgContextService.snapshot.activeTeamId || undefined;
      this.organizationService.listLibrary(id, appId, teamId, true).subscribe({
        next: (items) => {
          this.orgLibraryItems = items || [];
          this.isLoadingOrgLibrary = false;
          // Org users: stop public feed loading — library is the home content.
          this.isLoadingFlows = false;
          this.tempFlows = [];
          this.allFlowsLoaded = true;
          this.changeDetectorRef.detectChanges();
        },
        error: () => {
          this.orgLibraryItems = [];
          this.isLoadingOrgLibrary = false;
          this.isLoadingFlows = false;
          this.changeDetectorRef.detectChanges();
        },
      });
    };

    const orgId =
      this.orgContextService.snapshot.activeOrganization?.organizationId ||
      (this.orgContextService.snapshot.accountUsageMode === "organization"
        ? localStorage.getItem("activeOrganizationId")
        : null);
    if (!orgId) {
      this.orgContextService.load().subscribe((ctx) => {
        if (
          this.orgContextService.snapshot.accountUsageMode === "public" ||
          !ctx?.activeOrganization?.organizationId
        ) {
          this.orgModeOnly = false;
          this.isLoadingOrgLibrary = false;
          return;
        }
        const id = ctx.activeOrganization.organizationId;
        finish(ctx, id);
      });
      return;
    }
    finish(this.orgContextService.snapshot, orgId);
  }

  openOrgLibraryItem(item: any): void {
    if (!item?.contentId) return;
    if (item.contentType === "GuidePack") {
      this.router.navigate(["/view-guide-pack", item.contentId]);
      return;
    }
    const slug = this.generateUrlSlug(item.title || "flow") || "flow";
    this.router.navigate([`/guide/${slug}/${item.contentId}`]);
  }
}
